import { StepsRootProps } from '@chakra-ui/react';

export enum StepperVariants {
    Active = 'active',
    Inactive = 'inactive',
    Complete = 'complete',
    Pending = 'pending',
}

interface StepperStep {
    id: number;
    title: string;
    status?: StepperVariants | undefined;
}

export interface StepperProps extends StepsRootProps {
    steps: StepperStep[];
    activeStep: number;
}
